<template>
  <div class="flex-col justify-start page">
    <div class="flex-row justify-between items-center section">
      <div class="top">
        <div class="flex-row items-center space-x-12">
          <img class="shrink-0 image" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/9f77c430f9fdef0167549eba956b1aa8.png" />
          <span class="text">{{title}}</span>
        </div>
        <div class="flex-row items-center section_2 space-x-26">
          <span class="text_2">7日</span>
          <img class="shrink-0 image_2" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16957799887516952748.png" />
        </div>
      </div>
      <div :id="`main_${id}`" class="main" :style="{width: '100%' , height:'200px' }"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import moment from "moment"

export default {
  props: ['id', 'title'],
  data () {
    return {}
  },

  mounted () {
    // 获取当前日期
    const today = moment();
    // 创建一个数组来存储最近 7 天的日期
    const last7Days = [];
    // 循环 7 次，每次都减去一天并格式化日期，然后将格式化后的日期添加到数组中
    for (let i = 0; i < 7; i++) {
      const date = today.subtract(1, 'days').format('MM/DD');
      last7Days.push(date);
    }

    console.log("last7Days:", last7Days);
    this.last7Days = last7Days.reverse()
    this.renderEcharts()
  },

  methods: {
    renderEcharts () {
      var chartDom = document.getElementById(`main_${this.id}`);
      this.myChart = echarts.init(chartDom);

      var option;
      option = {
        grid: {
          top: 20,
          bottom: 20,
          right: 20
        },
        xAxis: {
          type: 'category',
          data: this.last7Days,
          axisLabel: {
            interval: 0, // 设置为 0，强制显示所有标签
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line'
          }
        ]
      };

      option && this.myChart.setOption(option);
    }

  }
}
</script>

<style lang="scss" scoped>
@import "./../codeFunCommon.scss";

.page {
  background-color: #f7f7f7;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  margin-top: 20px;

  .section {
    padding: 14px 12px;
    background-color: #ffffff;
    border-radius: 8.5px;
    flex-direction: column;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .space-x-12 {
      & > *:not(:first-child) {
        margin-left: 12px;
      }
      .image {
        border-radius: 17px;
        width: 30px;
        height: 30px;
      }
      .text {
        color: #333333;
        font-size: 16px;
        font-family: PingFang SC;
        line-height: 15px;
      }
    }
    .section_2 {
      padding: 8px 12px;
      border-radius: 4px;
      height: 32px;
      border: solid 1px #2a85ff;
      .text_2 {
        margin-left: 18px;
        color: #2a85ff;
        font-size: 14px;
        font-family: PingFang SC;
        line-height: 12px;
      }
      .image_2 {
        width: 9px;
        height: 6px;
      }
    }
    .space-x-26 {
      & > *:not(:first-child) {
        margin-left: 26px;
      }
    }
  }
}
</style>
